var render = function render(){var _vm=this,_c=_vm._self._c;return _c('closeable-tag',{attrs:{"active":_vm.active,"icon":['fas', 'square-check']},on:{"close":function($event){return _vm.$emit('close')},"open":function($event){return _vm.$emit('open')}}},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }